import { Store } from './gameStore';
import { GameName } from 'constants/difficulty';

export function fixedGameDifficulty(attrDifficulty: string) {
    const gameDifficulty = attrDifficulty.toUpperCase();
    let fixedDifficulty = '';
    switch (Store.name) {
        case GameName.KLONDIKE:
            fixedDifficulty = `KLONDIKE_${gameDifficulty}_${Store.dealCount}`;

            break;
        case GameName.SPIDER:
            fixedDifficulty = `SPIDER_${gameDifficulty}_${Store.suits}`;
            break;
        case GameName.FREECELL:
            fixedDifficulty = `FREECELL_${gameDifficulty}`;

            break;
        case GameName.PYRAMID:
            fixedDifficulty = `PYRAMID_${gameDifficulty}`;
            break;
    }
    return fixedDifficulty;
}
